import Input from "./General/Input";
import { useRef, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAPIList } from "../store/CoreSlice";
import styled from "styled-components";
import homeStyles from "../styles/Home/Home.module.css";
import { MixpanelTracking } from "../MixPanel";
import useDidMountEffect from "../hooks/useDidMountEffect";
import { useRouter } from "next/router";

const StyledSearchDiv = styled.div`
	color : #EC6303;
	padding : 5px;

	@media all and (min-width : 1024px) {
		padding : 10px;
	}
`

function ProductSearch(props : any) {
	const dispatch : any = useDispatch();
	const { apiList: { list } } = useSelector((state: any) => state.core);
    const [showSearch, setShowSearch] : any = useState(false);	
	const [searchText, setSearchText] : any = useState('');
	const inputRef = useRef(null);
    const mixPanelData = useRef({});
    const router = useRouter()

    useEffect(() => {
        setSearchText('');
    }, [router.asPath]);

    useDidMountEffect(() => {
        let count = 0;
        list.forEach((product : any) => {
            if(product.deals_count)
                count += 1;
        })

        mixPanelData.current = {
            ...mixPanelData.current,
            searchResultCount : list.length,
            searchResultWithDealsCount : count,
            searchResultTerms : list
        }

        MixpanelTracking.getInstance().searched(mixPanelData.current);
    }, [searchText])

    const handleSearchBlur = () => {
		setTimeout(() => {
			setShowSearch(false)
		}, 300);
	}
	
	const handleSearch = (event : any) => {
		setShowSearch(true);
		setSearchText(event.target.value)
		const params = {
			page : 1,
			page_size : 5,
			search : event.target.value
		}
		dispatch(getAPIList(params));
        mixPanelData.current = {...mixPanelData.current, searchTerm : event.target.value}
	}

    const navigateToPDP = (slug : string) => {
        router.push(`/products/${slug}`)
    }

    return (
        <div className="relative">
            <Input
                ref={inputRef}
                search
                onInput={handleSearch}
                onBlur={handleSearchBlur}
                value={searchText}
                name="ProductSearch"
                searchResults={
                    showSearch &&
                    list.map((data: any, index: number) => (
                        <div onClick={() => navigateToPDP(data.slug)} key={index} className="flex justify-between text-[15px] my-3 py-2 text-theme-black font-light cursor-pointer rounded flex items-center hover:bg-[#D4D9E7]/50 font-semibold">
                            <p className="flex flex-col font-light">
                                <span>
                                    {data.name} ({data.cas_number})
                                </span>
                                <small> {data.product_type} </small>
                            </p>
                            {
                                data.deals_count > 0 &&
                                <p className="flex items-center">
                                    <div className={homeStyles.dot}></div>
                                    {data.deals_count > 1 ? data.deals_count + ' Live Deals' : data.deals_count + ' Live Deal'}
                                </p>
                            }
                        </div>
                    ))
                }
                prefix={
                    <StyledSearchDiv className={`m-[9px] ml-[5px] lg:m-[3px] ${props.prefixStyles}`}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={`${props.searchIconHeight}`}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                        </svg>
                    </StyledSearchDiv>
                }
                // suffix = {
                // 	<StyledMic className="cursor-pointer">
                // 		<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                // 			<path strokeLinecap="round" strokeLinejoin="round" d="M12 18.75a6 6 0 006-6v-1.5m-6 7.5a6 6 0 01-6-6v-1.5m6 7.5v3.75m-3.75 0h7.5M12 15.75a3 3 0 01-3-3V4.5a3 3 0 116 0v8.25a3 3 0 01-3 3z" />
                // 		</svg>
                // 	</StyledMic>
                // }
                placeholder='Search Product / CAS number'
                outerProperties={`
                    rounded-[5px]
                    ${props.shadow && 'drop-shadow-md'}
                    ${props.styles}
                `}
                properties = {`
                    rounded-[5px] placeholder:text-[#616161] placeholder:text-[12px] placeholder:font-[300] lg:placeholder:text-[14px]
                `}
                additionalStyles = {{
                    filter : props.shadow ? 'drop-shadow(0px 4px 14px rgba(0, 0, 0, 0.11))' : 'none',
                    border: props.shadow ? '1px solid rgba(191, 191, 191, 0.3)' : '0.5px solid rgba(191, 191, 191, 0.8)'
                }}
            />
        </div>
    )
}

ProductSearch.defaultProps = {
    shadow : true,
    styles : '',
    searchIconHeight : 'w-4 h-4 lg:w-8 lg:h-8',
    prefixStyles : ''
}

export default ProductSearch